// @flow

const myBidsFilterOptions = {
    ALL: 'ALL',
    LOST: 'LOST',
    WON: 'WON',
};

export default myBidsFilterOptions;
